import { render, staticRenderFns } from "./LogDetails.vue?vue&type=template&id=36d72b84&"
import script from "./LogDetails.vue?vue&type=script&lang=js&"
export * from "./LogDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports